/**
 * Returns the API full url for a given endpoint.
 * @param endpoint The internal API endpoint.
 */
export default function buildSternumApiUrl(endpoint: string): string {
    return `${process.env.STERNUM_API_ENDPOINT}${endpoint}`;
}
